import type { useTranslate } from '@festina-life/ui/hooks'

import { ErrorMessageBody } from './ErrorMessageBody'
import { toTitle } from './utils'

export const errorMessageToastContent = ({
  error,
  translate,
}: {
  error: unknown
  translate: ReturnType<typeof useTranslate>
}) => ({
  title: toTitle(error, translate),
  message: <ErrorMessageBody error={error} />,
  variant: 'error' as const,
})
